import { useState } from "react";
import { mockUser } from "../../../mocks/account";

export default function SettingsPanel() {
  const [saved, setSaved] = useState(false);
  const [firstName, setFirstName] = useState(mockUser.firstName);
  const [lastName, setLastName] = useState(mockUser.lastName);
  const [email] = useState(mockUser.email);
  const [phone, setPhone] = useState(mockUser.phone);

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  return (
    <div className="space-y-6">
      <h2 className="font-bold text-slate-900 text-xl font-playfair">Kontoeinstellungen</h2>

      {/* Profile Edit */}
      <div className="bg-white rounded-2xl border border-slate-100 p-7">
        <h3 className="font-semibold text-slate-800 mb-5 flex items-center gap-2">
          <span className="w-7 h-7 flex items-center justify-center bg-sky-100 text-sky-600 rounded-full"><i className="ri-user-line text-sm"></i></span>
          Persönliche Informationen
        </h3>
        <form onSubmit={handleSave} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="text-xs font-medium text-slate-600 block mb-1">Vorname</label>
              <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-secondary transition-colors" />
            </div>
            <div>
              <label className="text-xs font-medium text-slate-600 block mb-1">Nachname</label>
              <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-secondary transition-colors" />
            </div>
          </div>
          <div>
            <label className="text-xs font-medium text-slate-600 block mb-1">Email</label>
            <input type="email" value={email} readOnly className="w-full bg-slate-100 border border-slate-200 rounded-lg px-4 py-3 text-sm text-slate-400 cursor-not-allowed" />
            <p className="text-xs text-slate-400 mt-1">Die E-Mail-Adresse kann nicht direkt geändert werden. Kontaktieren Sie den Support.</p>
          </div>
          <div>
            <label className="text-xs font-medium text-slate-600 block mb-1">Telefon</label>
            <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} className="w-full bg-slate-50 border border-slate-200 rounded-lg px-4 py-3 text-sm focus:outline-none focus:border-secondary transition-colors" />
          </div>
          <div className="flex items-center gap-3 pt-2">
            <button type="submit" className="bg-sky-500 hover:bg-sky-600 text-white font-semibold px-8 py-3 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
              Speichern
            </button>
            {saved && (
              <span className="text-secondary-dark text-sm font-medium flex items-center gap-1">
                <span className="w-4 h-4 flex items-center justify-center"><i className="ri-checkbox-circle-line"></i></span>
                Gespeichert!
              </span>
            )}
          </div>
        </form>
      </div>

      {/* Security */}
      <div className="bg-white rounded-2xl border border-slate-100 p-7">
        <h3 className="font-semibold text-slate-800 mb-5 flex items-center gap-2">
          <span className="w-7 h-7 flex items-center justify-center bg-emerald-100 text-secondary-dark rounded-full"><i className="ri-lock-line text-sm"></i></span>
          Sicherheit
        </h3>
        <div className="space-y-3">
          <div className="flex items-center justify-between py-3 border-b border-slate-50">
            <div>
              <p className="text-sm font-medium text-slate-700">Passwort</p>
              <p className="text-xs text-slate-400">Letzte Änderung: vor 3 Monaten</p>
            </div>
            <button className="text-sky-500 hover:text-sky-600 text-sm font-medium cursor-pointer whitespace-nowrap border border-sky-200 px-4 py-2 rounded-lg hover:bg-sky-50 transition-colors">
              Ändern
            </button>
          </div>
          <div className="flex items-center justify-between py-3">
            <div>
              <p className="text-sm font-medium text-slate-700">Zwei-Faktor-Authentifizierung</p>
              <p className="text-xs text-slate-400">Erhöht die Sicherheit Ihres Kontos</p>
            </div>
            <button className="text-secondary hover:text-secondary-dark text-sm font-medium cursor-pointer whitespace-nowrap border border-emerald-200 px-4 py-2 rounded-lg hover:bg-emerald-50 transition-colors">
              Aktivieren
            </button>
          </div>
        </div>
      </div>

      {/* Danger Zone */}
      <div className="bg-red-50 rounded-2xl border border-red-100 p-6">
        <h3 className="font-semibold text-red-700 mb-2">Gefahrenzone</h3>
        <p className="text-red-600 text-sm mb-4">Die Löschung des Kontos ist endgültig und unumkehrbar.</p>
        <button className="border border-red-300 text-red-600 hover:bg-red-100 text-sm font-medium px-5 py-2.5 rounded-lg transition-colors cursor-pointer whitespace-nowrap">
          Mein Konto löschen
        </button>
      </div>
    </div>
  );
}
